import { useEffect } from 'react';
import { useFirstMountState } from '../useFirstMountState/index.js';

//https://github.com/streamich/react-use/blob/master/src/useUpdateEffect.ts
var useUpdateEffect = function (effect, deps) {
    var isFirstMount = useFirstMountState();
    useEffect(function () {
        if (!isFirstMount) {
            return effect();
        }
    }, deps);
};

export { useUpdateEffect };
//# sourceMappingURL=index.js.map
